<template>
  <div>
    <el-dialog :visible.sync="showDialog"
               width="700px"
               :show-close="false"
               :append-to-body="true"
               custom-class="confirm-dialog-cpn"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <div class="data-check">
        <div class="title">数据范围规范检查</div>
        <div v-if="error"
             class="error-message">{{ error }}</div>
        <div class="table-wrapper">
          <table>
            <tr>
              <th>时间范围</th>
              <td>{{ timeRange }}</td>
            </tr>
            <tr>
              <th>类目选择</th>
              <td>
                <div v-for="category in categories"
                     :key="category">{{ category }}</div>
              </td>
            </tr>
            <tr :class="params.titleErrorType != -1 ? 'error-row' : ''">
              <th>商品标题过滤条件</th>
              <td>

                <template v-if="params.titleErrorType != -1">
                  <div v-html="params.parse_word_title"></div>
                  <template v-if="params.parse_word_subtitle">
                    <div v-html="params.parse_word_subtitle"></div>
                  </template>
                </template>
                <div v-if="params.title && params.titleErrorType == -1">系统会按照以下格式来理解您输入的关键词表达式</div>
                <div v-if="params.title"
                     class="word-btn"
                     v-html="params.titleErrorType != -1 ? params.parse_word : params.title"></div>
                <div v-if="params.title && params.titleErrorType == -1">确认逻辑无误再提交搜索，数据更精准确哦</div>
              </td>
            </tr>
            <tr :class="params.brandErrorType != -1 ? 'error-row' : ''">
              <th>品牌过滤条件</th>
              <td>
                <template v-if="params.brandErrorType != -1">
                  <div v-html="params.parse_brand_title"></div>
                  <template v-if="params.parse_brand_subtitle">
                    <div v-html="params.parse_brand_subtitle"></div>
                  </template>
                </template>
                <div v-if="params.brand && params.brandErrorType == -1">系统会按照以下格式来理解您输入的关键词表达式</div>
                <div v-if="params.brand"
                     class="word-btn"
                     v-html="params.brandErrorType != -1 ? params.parse_brand : params.brand"></div>
                <div v-if="params.brand && params.brandErrorType == -1">确认逻辑无误再提交搜索，数据更精准确哦</div>
              </td>
            </tr>
          </table>
        </div>

        <div class="buttons">
          <button class="submit-btn"
                  @click="() => {this.$emit('confirmClick')}">确认提交</button>
          <button class="back-btn"
                  @click="() => {this.$emit('backClick')}">返回修改</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      timeRange: '2025-01 ~ 2025-07',
      categories: [],
      error:
        '您提交的数据筛选条件存在异常，可能导致分析数据有误/缺失！建议您返回修改！',
      showTitleFilter: false,
      showBrandFilter: false,
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: null,
    },
  },
  computed: {},
  methods: {},
  created() {},
  watch: {
    params: {
      handler(newVal) {
        this.timeRange = newVal.timeRange.join(' ~ ')
        this.categories = newVal.cats.map((item) => {
          return item.path.join(' > ')
        })
      },
    },
  },
}
</script>

<style lang="less">
.confirm-dialog-cpn {
  background-color: transparent !important;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
    border-radius: 10px;
    background-color: transparent;
  }
  .data-check {
    width: calc(100% - 40px);
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 10px;
    background-color: #fff;
    .title {
      color: #000;
      font-size: 16px;
      text-align: center;
      font-weight: 500;
    }
  }

  .error-message {
    color: red;
    text-align: center;
    margin: 6px 0 18px 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    background-color: #f8f8f8;
    border-radius: 10px;
  }

  th,
  td {
    padding: 10px 20px;
    border-bottom: 4px solid #fff;
  }

  th {
    text-align: right;
    border-right: 4px solid #fff;
    min-width: 200px;
  }

  .error-row {
    background-color: #ff000010;
  }
  .table-wrapper {
    border-radius: 10px;
    overflow: hidden;
  }
  .buttons button {
    margin: 10px;
    padding: 10px 20px;
    cursor: pointer;
  }

  .buttons button:hover {
    background-color: #2f4eff;
    color: white;
  }
  .word-btn {
    background-color: transparent;
    border-radius: 14px;
    border: 1px solid #000;
    padding: 5px 10px;
    display: inline-block;
    font-size: 12px;
    margin: 5px 0;
  }
  .buttons {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    .back-btn {
      background-color: #2f4eff;
      color: #fff;
      border-radius: 8px;
      padding: 0;
      border: none;
      width: 98px;
      height: 40px;
      font-size: 14px;
    }

    .submit-btn {
      background-color: #f0f2ff;
      color: #b9c3ff;
      border-radius: 8px;
      padding: 0;
      border: none;
      width: 98px;
      height: 40px;
      font-size: 14px;
    }
  }
}
</style>
